// @flow

import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import axios from 'axios';

import config from '../../config';
import { getToken } from '../../lib/utils';

type Props = {
  role: boolean,
  uploadUrl: string,
  pageContext: string,
  multiple: boolean,
  onUploadFail?: () => void,
};

type State = {
  error: string,
  progress: number,
  file: Object | null,
  isUploading: boolean,
  imagePreviewUrl: Array<string>,
};

const INITIAL_STATE: State = {
  error: '',
  file: null,
  progress: 0,
  isUploading: false,
  imagePreviewUrl: '',
};

export default class ImageUploader extends Component<Props, State> {
  state = INITIAL_STATE;
  static defaultProps = {
    onUploadFail: () => {},
  };
  render() {
    const { file, imagePreviewUrl, progress, isUploading, error } = this.state;
    const { children, pageContext, role, multiple } = this.props;

    return (
      <Fragment>
        {children(imagePreviewUrl)}
        {role ? (
          <div
            className={
              isUploading ? 'progress-bar-holder uploading' : 'progress-bar-holder'
            }
          >
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: progress + '%' }}
            >
              <span className="sr-only">{progress}% Complete</span>
            </div>
          </div>
        ) : null}
        {role ? (
          <div className={`uploader ${pageContext}`}>
            <p className="error">{error}</p>
            <input
              style={{ display: 'none' }}
              type="file"
              accept="image/*"
              multiple={multiple}
              onChange={this.handleImageChange}
              ref={input => {
                this.fileInput = input;
              }}
            />
            <Button
              color="primary"
              className={pageContext}
              onClick={() => this.fileInput.click()}
            >
              Change Image
            </Button>

            {file ? (
              <Fragment>
                <Button color="primary" className={pageContext} onClick={this.uploadImage}>
                  Save
                </Button>
                <Button color="primary" className={pageContext} onClick={this.cancelEdit}>
                  Cancel
                </Button>
              </Fragment>
            ) : null}
          </div>
        ) : null}
      </Fragment>
    );
  }

  handleImageChange = e => {
    e.stopPropagation();
    e.preventDefault();

    // console.log(e.target.files);

    const file = e.target.files;

    const files = Array.from(file);
    this.setState({ file: files });

    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();
      reader.readAsDataURL(file[i]);
      reader.onloadend = () => {
        this.setState({
          imagePreviewUrl: [...this.state.imagePreviewUrl, reader.result],
        });
      };
    }
  };

  uploadImage = () => {
    this.setState({ isUploading: true, error: '' });
    this.upload();
  };

  cancelEdit = () => {
    this.setState(INITIAL_STATE);
  };

  onUploadProgress = e => {
    this.setState({
      progress: Math.round((e.loaded / e.total) * 100),
    });
  };

  upload = async () => {
    const fd = new FormData();
    const { file } = this.state;
    const { onUploadFail } = this.props;
    file.forEach(file => {
      fd.append('file', file, { 'Content-Type': 'image/jpeg' });
    });
    try {
      await axios({
        method: 'PUT',
        url: `${config.ENDPOINT}/${this.props.uploadUrl}`,
        data: fd,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `JWT ${getToken()}`,
          Accept: 'application/json',
        },
        onUploadProgress: this.onUploadProgress,
      });
      window.location.reload();
    } catch (e) {
      onUploadFail && onUploadFail(e);
      this.setState({
        isUploading: false,
        error: e.response
          ? e.response.data.message
          : 'Could not upload your image. Please try again later.',
        progress: 0,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/ImageUploader/ImageUploader.jsx